import React from 'react';
import Icon from './Icon';

export default function ActionTile({ icon, label, onClick, active = false, accent = '#e60073' }) {
    return (
        <button
            onClick={onClick}
            style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5,
                padding: '11px 4px',
                background: '#0E0E10', border: '1px solid #1A1A1D', borderRadius: 12,
                color: active ? accent : '#E4E4E7',
                cursor: 'pointer', width: '100%',
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 10.5, fontWeight: 500,
                transition: 'background 120ms',
            }}
        >
            <Icon name={icon} size={18} color={active ? accent : '#E4E4E7'} stroke={1.7} />
            <span style={{ letterSpacing: 0.2 }}>{label}</span>
        </button>
    );
}
